import { useState } from "react";
import { useTranslation } from "react-i18next";
import { RadioButtonWithLabel } from "../../core/components/buttons/RadioButtonWithLabel";
import { DatePicker } from "../../core/components/input/DatePicker";
import { InfoText } from "../../core/components/texts/InfoText";
import {
  getAppointmentActionType,
  getAppointmentToModifyDateTime,
} from "../../core/store/appointmentSlice";
import { getCurrentPracticeAppointmentRequestFlags } from "../../core/store/chainSlice";
import { useMainStore } from "../../core/store/mainStore";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";

export const AppointmentModificationTimeAndDate = () => {
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();
  const appointmentToModifyDateTime = useMainStore(
    getAppointmentToModifyDateTime,
  );
  const actionType = useMainStore(getAppointmentActionType);
  const setAppointmentToModifyDateTime = useMainStore(
    (state) => state.setAppointmentToModifyDateTime,
  );
  const appointmentRequestFlags = useMainStore(
    getCurrentPracticeAppointmentRequestFlags,
  );
  const [shortNoticeConfirmed, setShortNoticeConfirmed] = useState(false);

  // Asked whatever date was entered: a practice's own text can name another notice period than 24 hours.
  const requiresShortNoticeConfirmation =
    !appointmentRequestFlags?.hideShortNoticeConfirmation;
  const shortNoticeConfirmationText =
    appointmentRequestFlags?.shortNoticeConfirmationText?.trim() ||
    t("APPOINTMENT_SHORT_NOTICE_CONFIRMATION");

  const handleDateChange = (dateTime: string) => {
    setAppointmentToModifyDateTime(dateTime);
  };

  const handleNext = () => {
    navigate();
  };

  return (
    <AppointmentScreenWrapper
      onNext={handleNext}
      nextButtonDisabled={
        !appointmentToModifyDateTime ||
        (requiresShortNoticeConfirmation && !shortNoticeConfirmed)
      }
    >
      <InfoText
        headline={
          actionType === "cancellation"
            ? t("APPOINTMENT_CANCELLATION_SCREEN_TITLE")
            : t("APPOINTMENT_RESCHEDULING_SCREEN_TITLE")
        }
        text={[t("APPOINTMENT_CANCELLATION_SCREEN_DESCRIPTION")]}
      />
      <DatePicker
        label={t("APPOINTMENT_CANCELLATION_SCREEN_DATE_LABEL")}
        date={appointmentToModifyDateTime}
        onChange={handleDateChange}
        withoutError
      />
      {requiresShortNoticeConfirmation && (
        <RadioButtonWithLabel
          isChecked={shortNoticeConfirmed}
          onPress={setShortNoticeConfirmed}
          text={shortNoticeConfirmationText}
          checkBoxIconName="CheckBoxSquareInactive"
        />
      )}
    </AppointmentScreenWrapper>
  );
};
